import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { SEARCH_REP } from '../../constants/repTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { repListSchema } from '../../schemas/Normalizr';

export function* searchRep(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

    const params = action.payload;

  try {
    yield *httpSaga(SEARCH_REP, call(repAPI.search, params), repListSchema);
  } catch (e) {
    yield put(error(SEARCH_REP, e));
  } finally {
    yield put(doneIndicator(SEARCH_REP));
  }
}

export function* watchSearchRep() {
  yield takeEvery(SEARCH_REP, searchRep);
}

export default function* root() {
  yield all([
    fork(watchSearchRep)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/searchRep.js